<template>
  <div class="profile-container">
    <div v-if="user">
      <el-row :gutter="20">
        <el-col :span="6" :xs="24">
          <user-card />
        </el-col>

        <el-col :span="18" :xs="24">
          <el-card class="right-container">
            <el-tabs v-model="activeTab">
              <el-tab-pane label="基本信息" name="enterprise-info" />
              <el-tab-pane label="开票信息" name="billing" />
              <el-tab-pane label="企业账户" name="bank-account" />
              <el-tab-pane label="转让BOSS权限" name="transfer-boss" v-if="isBoss" />
            </el-tabs>
            <component :is="activeTab"></component>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import UserCard from "./components/UserCard";
import EnterpriseInfo from "./components/EnterpriseInfo";
import Billing from "./components/Billing";
import BankAccount from "./components/BankAccount";
import TransferBoss from "./components/TransferBoss";

export default {
  name: "Profile",
  components: { UserCard, Billing, EnterpriseInfo, BankAccount, TransferBoss },
  data() {
    return {
      user: {},
      isBoss: false,
      activeTab: "enterprise-info"
    };
  },
  created() {
    this.checkUserIsBoss();
  },
  methods: {
    checkUserIsBoss() {
      this.$api.isCurrentEnterpriseBoss().then(res => (this.isBoss = res));
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";

.profile-container {
  $margin: 15px;
  margin: $margin;

  .right-container {
    min-height: calc(100vh - #{$topMenuHeight} - #{$margin}* 2);
  }
}
</style>
